import type { ReactNode } from "react";
import { useProjectPermissions } from "@/app/capabilities/api/hooks";
import type { ProjectPermission } from "@/app/capabilities/types";

type CanProjectProps = {
  permission: ProjectPermission;
  children: ReactNode;
};

/**
 * Render children only if the caller holds the project permission. Use for gating
 * a JSX element (button, card, link). For array filtering or boolean logic, use
 * the `useProjectPermissions().canProject` hook directly instead.
 */
export function CanProject({ permission, children }: CanProjectProps) {
  const { canProject } = useProjectPermissions();

  if (!canProject(permission)) {
    return null;
  }

  return children;
}
